"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VEGETARIAN_DAY = void 0;
exports.VEGETARIAN_DAY = [1, 8, 14, 15, 18, 23, 24, 28, 29, 30];
